"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const LifecycleChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleChartSettingsJSONModel");
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const LifecycleGranularityJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleGranularityJSONModel");
class LifecycleJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.granularityJSONModel = new LifecycleGranularityJSONModel_1.LifecycleGranularityJSONModel();
        this.chartSettingsJSONModel = new LifecycleChartSettingsJSONModel_1.LifecycleChartSettingsJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.granularityJSONModel.reset();
            this.chartSettingsJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.granularityJSONModel.overwriteFromSerializedState(serializedState.granularity);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                granularity: this.granularityJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getGranularityJSONModel = () => this.granularityJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.LifecycleJSONModel = LifecycleJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
LifecycleJSONModel.isModelEmpty = (serializedState) => {
    return true;
};
LifecycleJSONModel.makeModelStateClean = (serializedState) => {
    return serializedState;
};
